import { Heart } from 'lucide-react'
import { Link } from 'react-router-dom'

type DonateButtonProps = {
  className?: string
  label?: string
  icon?: boolean
  href?: string
}

export default function DonateButton({
  className = 'button button--gold',
  label = 'Donate',
  icon = true,
  href = '/donate',
}: DonateButtonProps) {
  const contents = (
    <>
      {icon && <Heart size={17} aria-hidden="true" />}
      {label}
    </>
  )

  if (href.startsWith('/')) {
    return <Link className={className} to={href}>{contents}</Link>
  }

  if (href.startsWith('#')) {
    return <a className={className} href={href}>{contents}</a>
  }

  return (
    <a className={className} href={href} target="_blank" rel="noopener noreferrer">
      {contents}
    </a>
  )
}
